import React, { useMemo } from "react";
import { Alert, Box } from "@mui/material";
import { PermitRouteMapDto } from "../../api/permitRouteMapService";
import PermitRouteMap from "../../components/Permits/PermitRouteMap/PermitRouteMap";

const decodeSharePayload = (value: string): PermitRouteMapDto | null => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    "=",
  );
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes)) as PermitRouteMapDto;
};

const routeTextFromMapData = (mapData?: PermitRouteMapDto | null) =>
  mapData?.steps
    .map(
      (step) =>
        `${step.order}. ${step.instruction ?? step.coordinate?.label ?? "Route step"}`,
    )
    .join("\n") ?? "";

const PublicPermitRouteMapPage: React.FC = () => {
  const sharedMapData = useMemo(() => {
    const mapHashValue = window.location.hash.match(/(?:^#|&)map=([^&]+)/)?.[1];
    if (!mapHashValue) return null;

    try {
      return decodeSharePayload(decodeURIComponent(mapHashValue));
    } catch {
      return null;
    }
  }, []);
  const activeRouteText = routeTextFromMapData(sharedMapData);

  if (!sharedMapData) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          This public permit map link is missing or invalid.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ height: "100vh", width: "100vw" }}>
      <PermitRouteMap
        routeText={activeRouteText}
        existingMapData={sharedMapData}
        autoGenerate={false}
        showShareLink={false}
        readOnly
        minimal
        height="100vh"
      />
    </Box>
  );
};

export default PublicPermitRouteMapPage;
